import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodGlucoseHistoryPage = lazy(() => import("./BloodGlucoseHistoryPage"));

const BloodGlucoseHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodGlucoseHistoryPage />
    </Suspense>
  );
};

export default BloodGlucoseHistoryPageLazy;
